export interface LanguageMetaData {
    versionNo: string;
    deployTime: string;
    branch: string;
}

/**
 * GGS language files (JSON) contain metadata info and then key-value pairs with the translations
 */
export interface LanguageData {
    "@metadata": LanguageMetaData;
    // "dynamic" class behaviour (this is necessary for the key value pairs)
    [prop: string]: any;
}

export function instanceOfLanguageMetaData(obj: any): obj is LanguageMetaData {
    return obj && obj.branch !== undefined && obj.versionNo !== undefined && obj.deployTime !== undefined;
}
export function instanceOfLanguageData(obj: any): obj is LanguageData {
    return obj && obj["@metadata"] !== undefined && instanceOfLanguageMetaData(obj["@metadata"]);
}
